<template>
  <div>
    <!-- <h4>Download</h4> -->
    <!-- <p>{{ msg }}</p> -->
    <H4>NewCloud AI 口语评测软件临时下载</H4>
    <texts class="contener">
      <li>
        <a href="NewCloudAISpeech.apk"
          >下载安卓应用 NewCloudAISpeech.apk V1.06
        </a>
      </li>
      <br />
      <li>
        <a href="NewCloudAISpeech_x86_V1.06.zip">
          下载WINDOWS 应用 NewCloudAISpeech_x86_V1.06.zip
        </a>
      </li>
      <br />
      <texts class="contener">
        (使用 Windows 版本的程序，请先
        <a href="https://developer.microsoft.com/zh-cn/microsoft-edge/webview2/"
          >安装 webview2 模块</a
        >，选择32位安装包下载安装。)
      </texts>
    </texts>
  </div>
</template>
<script>
export default {
  data() {
    return {
      msg: "下载",
    };
  },
};
</script>